import { CSS } from "@dnd-kit/utilities"
import { useSortable } from "@dnd-kit/sortable"
import { CampingStyleProps } from "~/interfaces"
import { Bars4Icon, ChevronDownIcon } from "@heroicons/react/24/outline"
import formatCampingStyleName from "~/utils/formatCampingStyleName"

interface Props {
  style: CampingStyleProps
  children: React.ReactNode
  isCollapsed?: boolean
  siteCount?: number
}

export default function SortableStyle({ style, children, isCollapsed = false, siteCount = 0 }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: style.id })

  const styleObj = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div ref={setNodeRef} style={styleObj} {...attributes} className="space-y-2">
      <div className="flex items-center gap-2 mb-2">
        <Bars4Icon className="w-6 h-6 cursor-move" {...listeners} />
        <h3 className="font-bold text-lg">{formatCampingStyleName(style.name)}</h3>
        {siteCount > 0 && (
          <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
            {siteCount} site{siteCount !== 1 ? 's' : ''}
          </span>
        )}
        {isCollapsed && (
          <ChevronDownIcon className="w-5 h-5 text-gray-400" />
        )}
      </div>
      {children}
    </div>
  )
}
